import { useFlags } from '@project44/feature-flags';
import { useUser } from '@project44/ui-utils';

export type TFeatureFlags = {
  featureExc1365: boolean; // Enable Contains Option
  featureExc1914: boolean; // Origin Grouping
  featureExc2061: boolean; // BMW landing page
  featureExc2098: boolean; // Identifier Types -> SERIAL_NUMBER, VEHICLE_IDENTIFICATION_NUMBER
  featureExc2119: boolean; // Carrier/Supplier Visibility Column
  featureExc2120: boolean; // Shared Visibility filter
  featureExc2131: boolean; // Order reference key filter
  featureExc2291: boolean; // Recommended Views
};

export type TPermissions = {
  canViewChat: boolean; // Chatbot
  canViewOrders: boolean; // Allow Orders List
};

function usePermissions() {
  const { data: user } = useUser();
  const flags = useFlags();

  const isAllowed = (token: string) =>
    Boolean(user?.authorities?.some(({ authority }) => authority === token));

  return {
    flags,
    permissions: {
      canViewChat: isAllowed('create:movement-ai-bot-chats'),
      // TODO Permissions disabled until client settings are updated
      // Will use deprecated 'orderListVisible flag' until then
      // canViewOrders: isAllowed('ORDER_VISIBILITY_UI'),
      canViewOrders: isAllowed('ORDER_VISIBILITY_UI') || flags.orderListVisible,
    },
  };
}

export default usePermissions;
